import { atom } from "jotai";

/**
 * Form-status atoms — the validity / submitting flags for the participant
 * decision form, migrated off the redux promptStore.
 *
 * These are intentionally module-global (no Provider): there is a single
 * active decision form at a time, and the submit/continue button that reads
 * them is rendered OUTSIDE the form's React tree (it's a sibling ContentBlock
 * under the page, not a descendant of the FormProvider), so a global bridge is
 * required to carry validity across that gap.
 *
 * `formInvalidAtom` is the single source of truth for "should submit be
 * blocked." It is projected from React Hook Form's real validation result by
 * the one effect in FormContentBlockProvider — never written ad hoc from inside
 * a validation pass. That projection is what keeps the red error message and
 * the disabled button reading the same signal.
 */
export const formInvalidAtom = atom(false);
formInvalidAtom.debugLabel = "formInvalidAtom";

export const formSubmittingAtom = atom(false);
formSubmittingAtom.debugLabel = "formSubmittingAtom";
